@if (form) {
  <form [formGroup]="form">
    @if (loaded) {
      <se-fe-form-field
    [seFeDataConfig]="{
      label: seFeDataLabel,
      errorMessages: {
        required: 'SE_PO_UI_ETHNICITY_SELECT.ERRORS.required' | translate
      }
    }">
      <se-fe-form-field-multiselect
        [formControlName]="ngControl.name"
        [seFeDataOptions]="options"
        seFeDataComfy="true">
      </se-fe-form-field-multiselect>
    </se-fe-form-field>
  }
</form>
}
